import { render, staticRenderFns } from "./beneficiary-edit-bt-ifsc-code.vue?vue&type=template&id=a60c6412&"
import script from "./beneficiary-edit-bt-ifsc-code.vue?vue&type=script&lang=js&"
export * from "./beneficiary-edit-bt-ifsc-code.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports